
import { Component, Vue, Prop } from "vue-property-decorator";
import Popup from "../../components/popup/popup.vue";
import BookingByPlaceMatchCard from "../bookingByPlaceCard/bookingByPlaceMatchCard.vue";
import PopupConfirmByPlace from "../../components/popupConfirmByPlace/popupConfirmByPlace-v2.vue";
import { Watch } from "vue-property-decorator";

@Component({
  components: {
    Popup,
    BookingByPlaceMatchCard,
    PopupConfirmByPlace,
  },
})
export default class MatchesBanner extends Vue {
  @Prop({ required: true, type: Array }) matches!: any[];
  currentIndex: number = 0;

  private get matchesToShow() {
    return this.matches.slice(0, 4);
  }

  matchSelected: any;
  showPopUpConfirm: boolean = false;

  @Watch("matches", { immediate: true, deep: true })
  onMatchesChanged(newMatches: any[]) {
    if (newMatches && newMatches.length > 0) {
      this.generateBlobsByPageHeight();
    }
  }

  async mounted() {
    this.checkScroll();
    window.addEventListener("resize", this.checkScroll);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScroll);
  }

  handleScroll(event: Event) {
    const container = event.target as HTMLElement;
    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth - container.clientWidth;

    const totalCards = this.matchesToShow.length;

    if (scrollWidth === 0) {
      this.currentIndex = 0;
      return;
    }

    const percent = scrollLeft / scrollWidth;
    this.currentIndex = Math.round(percent * (totalCards - 1));
  }

  scrollToCard(index: number) {
    const container = this.$refs.matchesBannerList as HTMLElement;
    const card = container.children[index] as HTMLElement;

    if (card && container) {
      container.scrollTo({
        left: card.offsetLeft,
        behavior: "smooth",
      });
    }
  }

  generateBlobsByPageHeight() {
    this.$nextTick(() => {
      const container = this.$refs.blobsContainer as HTMLElement;
      if (!container) return;

      container.innerHTML = "";

      const topRightBlob = document.createElement("div");
      topRightBlob.className = "blob";
      topRightBlob.style.top = "-100px";
      topRightBlob.style.right = "-100px";
      container.appendChild(topRightBlob);

      const bottomLeftBlob = document.createElement("div");
      bottomLeftBlob.className = "blob";
      bottomLeftBlob.style.bottom = "-100px";
      bottomLeftBlob.style.left = "-100px";
      container.appendChild(bottomLeftBlob);
    });
  }

  async joinBooking(e: any, booking: any) {
    e.preventDefault();

    const url =
      booking.bookingTemplateId !== null &&
      booking.bookingTemplateId !== undefined
        ? "/booking-visual/" +
          booking.id +
          "/" +
          booking.bookingTemplateId +
          "?date=" +
          booking.date
        : "/bookings-byplace?bookingId=" + booking.id + "&date=" + booking.date;

    if (this.$store.state.loggedIn === false) {
      this.$store.commit("openLogin", { backUrl: url });
      return;
    }

    if (
      booking.bookingTemplateId !== null &&
      booking.bookingTemplateId !== undefined
    ) {
      return this.$router.push(url);
    }

    this.matchSelected = booking;
    this.showPopUpConfirm = true;
  }

  checkScroll() {
    this.$nextTick(() => {
      const container = this.$refs.matchesBannerContainer as HTMLElement | null;
      const list = this.$refs.matchesBannerList as HTMLElement | null;

      if (container && list) {
        const hasHorizontalScroll = list.scrollWidth > container.clientWidth;
        list.style.justifyContent = hasHorizontalScroll
          ? "flex-start"
          : "center";
      }
    });
  }
}
